<div class="modal-welcome">
  <div class="modal-welcome__content">
    <div class="modal-welcome__content__title">
      <h1><img src="/assets/images/alert.png" alt=""> ¡Bienvenido a Triidy!</h1>
    </div>
    <div class="modal-welcome__content__text">
      <p>Acabas de dar el primer paso para ingresar al grandioso mundo del E-commerce.</p>
      <p>Escucha lo que Andrés Hernández tiene para tí.</p>
    </div>
    <div class="modal-welcome__content__video">
      <iframe title="vimeo-player"
        src="https://player.vimeo.com/video/796410735?h=d619ac2206?portrait=false&title=false" width="640" height="360"
        frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="modal-welcome__content__button">
      <a class="btn" href="https://www.triidypluss.com/Iniciaretotriidy">Ver el video exclusivo ahora</a>
    </div>
  </div>
</div>